<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE DISPOSITIVOS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <table mat-table [dataSource]="dataSource" matSort>
            <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->
            <!-- Columna referencia -->
            <ng-container matColumnDef="dev_reference">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Referencia </th>
            <td mat-cell *matCellDef="let element" class="dev-reference"> {{element.dev_reference}} </td>
            </ng-container>
        
            <!-- Columna nombre -->
            <ng-container matColumnDef="dev_label">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_label}} </td>
            </ng-container>

            <ng-container matColumnDef="establecimiento">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Establecimiento </th>
                <td mat-cell *matCellDef="let element" class="router-cell" routerLink="/establecimiento/{{element.est_id}}"> {{element.establecimiento}} </td>
            </ng-container>

            <ng-container matColumnDef="razon_social" *ngIf="userDataInfo.pro_id == 4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{ element.razon_social }} </td>
            </ng-container>
        
            <!-- Columna serie -->
            <ng-container matColumnDef="dev_serie">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Serie </th>
            <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_serie}} </td>
            </ng-container>
        
            <!-- Columna sim -->
            <ng-container matColumnDef="dev_sim">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº SIM </th>
            <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_sim}} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                <td mat-cell *matCellDef="let element" class="cell">
                  <ng-container *ngIf="element.estado == 'Desactivado'">
                    <span class="rojo">Desactivado</span>
                  </ng-container>
                  <ng-container *ngIf="element.estado == 'Activado'">
                    <span class="verde">Activado</span>
                  </ng-container>
                  <ng-container *ngIf="element.estado == 'Desconocido'">
                    <span class="gris">Desconocido</span>
                  </ng-container>
                </td>
            </ng-container>

            <!-- Columna fechaAlta -->
            <ng-container matColumnDef="dev_create_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha Alta </th>
                <td mat-cell *matCellDef="let element" class="cell"> {{element.dev_create_at}} </td>
            </ng-container>

            <!-- Columna operaciones -->
            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                  <div class="button-container">
                    <button mat-mini-fab class="ver-btn" matTooltip="Ver dispositivo" aria-label="Ver dispositivo" routerLink="/dispositivo/ver/{{element.id}}">
                      <mat-icon>remove_red_eye</mat-icon>
                    </button>
                    <button *ngIf="userDataInfo.pro_id == 4 || userDataInfo.pro_id == 1" mat-mini-fab class="edit-btn" matTooltip="Editar dispositivo" 
                    aria-label="Editar dispositivo" routerLink="/{{element.id}}/editar/dispositivo">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <mat-paginator 
            [pageSizeOptions]="[20, 40, 80]" 
            showFirstLastButtons 
            aria-label="Elige una página"
            class="customPaginator">
        </mat-paginator>
    </div>
</ng-container>